<template>
    <div>
        <Backer :isEnable="backEnable"></Backer>
        <Card shadow>
            <Row :gutter="18">
                <Col span="7" style="display:none">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">代理组:</span>
                        <Select v-model="table.params.platform" filterable placeholder="选择APP分组" clearable>
                            <Option v-for="(item, index) in plat_list" :value="item.id" :label="item.name" :key="index">
                                {{ item.name }}<span style="color: #bbb">({{ item.id }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">代理:</span>
                        <Select v-model="table.params.app_id" :disabled="!table.params.platform" filterable placeholder="选择APP盘口" clearable @on-change="appidChange">
                            <Option v-for="(item, index) in app_list.filter((item) => item.platform == table.params.platform)" :value="item.appid" :label="item.appName" :key="index">
                                {{ item.appName }}<span style="color: #bbb">({{ item.appid }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">筛选游戏:</span>
                        <Select v-model="table.params.gid" filterable clearable placeholder="下拉筛选游戏">
                            <Option v-for="(item, index) in select.game_list" :value="item.game_id" :label="item.game_name" :key="index">
                                {{ item.game_name }}
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">是否在线:</span>
                        <Select v-model="table.params.is_online" clearable placeholder="是否在线">
                            <Option v-for="item in select.online_list" :key="item.value" :label="item.name" :value="item.value">{{ item.name }}</Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">是否投注:</span>
                        <Select v-model="table.params.is_bet" clearable placeholder="是否投注">
                            <Option v-for="item in select.is_bet_list" :key="item.value" :label="item.name" :value="item.value">{{ item.name }}</Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">是否转入:</span>
                        <Select v-model="table.params.is_pay" clearable placeholder="是否转入">
                            <Option v-for="item in select.is_his_pay_list" :key="item.value" :label="item.name" :value="item.value">{{ item.name }}</Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">是否赠送:</span>
                        <Select v-model="table.params.is_give" clearable placeholder="是否赠送">
                            <Option v-for="item in select.fistgive_list" :key="item.value" :label="item.name" :value="item.value">{{ item.name }}</Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">是否首充:</span>
                        <Select v-model="table.params.is_fist_pay" clearable placeholder="是否首充">
                            <Option v-for="item in select.fistpay_list" :key="item.value" :label="item.name" :value="item.value">{{ item.name }}</Option>
                        </Select>
                    </label>
                </Col>
            </Row>
            <Row :gutter="18" style="margin-top: 10px">
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 170px">信息筛选时间:</span>
                        <DatePicker type="daterange" v-model="select.dataTime" placeholder="信息筛选时间" :options="dateOptions"></DatePicker>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 170px">是否绑定上级:</span>
                        <Select v-model="table.params.is_pid" clearable placeholder="是否绑定上级">
                            <Option v-for="item in select.is_pid_list" :key="item.value" :label="item.name" :value="item.value">{{ item.name }}</Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">注册时间:</span>
                        <DatePicker type="daterange" v-model="select.rdataTime" placeholder="注册时间" :options="dateOptions"></DatePicker>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">玩家ID:</span>
                        <Input v-model="table.params.uid" placeholder="搜索 玩家ID" clearable></Input>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">玩家昵称:</span>
                        <Input v-model="table.params.nick_name" placeholder="搜索 玩家昵称" clearable></Input>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">商户号:</span>
                        <Select v-model="table.params.general_no" filterable placeholder="选择 商户号" clearable>
                            <Option v-for="(item, index) in select.general_list" :value="item.general" :label="item.general_name" :key="index">
                                {{ item.general_name }}<span style="color: #bbb">({{ item.general }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">子商户 号:</span>
                        <!-- <Input v-model="table.params.pack_no" placeholder="搜索 子商户号" clearable></Input> -->
                        <Select
                            v-model="table.params.pack_no"
                            filterable
                            placeholder="选择 子商户
号"
                            clearable
                        >
                            <Option v-for="(item, index) in select.pack_list.filter((item) => item.general == table.params.general_no)" :value="item.pack_no" :label="item.pack_name" :key="index">
                                {{ item.pack_name }}<span style="color: #bbb">({{ item.pack_no }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 170px">是否历史转入:</span>
                        <Select v-model="table.params.is_his_pay" clearable placeholder="是否历史转入">
                            <Option v-for="item in select.is_his_pay_list" :key="item.value" :label="item.name" :value="item.value">{{ item.name }}</Option>
                        </Select>
                    </label>
                </Col>
            </Row>
            <Row :gutter="18" style="margin-top: 10px">
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">上级ID:</span>
                        <Input v-model="table.params.pid" placeholder="搜索 上级ID" clearable></Input>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">用户标签:</span>
                        <Select v-model="table.params.user_tag" clearable multiple placeholder="搜索 用户标签">
                            <Option v-for="(item, index) in select.user_tag_List" :key="index" :label="index" :value="index"></Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 170px">手动风控状态:</span>
                        <Select v-model="table.params.user_control_risk_type" clearable placeholder="搜索 手动风控状态">
                            <Option v-for="(item, index) in select.user_control_risk_type_list" :key="index" :label="item.name" :value="item.value">{{ item.name }}</Option>
                        </Select>
                    </label>
                </Col>
                <Col span="1">
                    <Button type="primary" @click="getUserRiskList(1)" :disabled="!table.params.app_id">查询</Button>
                </Col>
                <Col span="2">
                    <Button type="info" @click="modalUserShow" :disabled="!this.modalUser.data.length">批量玩家管理</Button>
                </Col>
                <Col span="8">
                    <span style="line-height: 28px">统计人数：{{ table.total }}</span
                    >&nbsp;&nbsp; <span style="line-height: 28px">转入总金额：{{ table.summary.pay_sum }}</span
                    >&nbsp;&nbsp;
                    <span style="line-height: 28px">转出总金额：{{ table.summary.put_sum }}</span>
                </Col>
                <!-- <Col span="2" style="float: right;">
                    <Button type="primary" :disabled="!table.params.app_id" @click="GetExcelList">导出数据</Button>
                </Col> -->
            </Row>
        </Card>
        <Table border :columns="table.columns" ref="selection" :data="table.data" style="margin-top: 10px" @on-selection-change="getSelection" @on-sort-change="changeSort"></Table>
        <Page v-show="table.data.length" style="margin-top: 10px" :current="table.params.page" :total="table.total" :page-size-opts="pageSizes" :page-size="table.params.limit" show-sizer @on-page-size-change="limitchange" @on-change="pagechange"></Page>
        <!-- 赠送金额 -->
        <Modal v-model="gift.show" width="800" style="text">
            <p slot="header" style="color: #1c2438; text-align: center">
                <span>赠送金额</span>
            </p>
            <div>
                <Table border size="large" style="width: 500px; margin: 10px auto" :columns="gift.column" :data="gift.data"></Table>
            </div>
        </Modal>
        <!-- 替它数据 -->
        <Modal v-model="other.show" width="1000">
            <p slot="header" style="color: #1c2438; text-align: center">
                <span>其他数据</span>
            </p>
            <Table border :columns="other.column" :data="other.data"></Table>
        </Modal>
        <!-- 投注详情 -->
        <Modal v-model="Bdetails.show" width="700">
            <p slot="header" style="color: #1c2438; text-align: center">
                <span>投注详情</span>
            </p>
            <Table border height="630" :columns="Bdetails.column" :data="Bdetails.data"></Table>
            <div slot="footer" style="text-align: center">
                <Button type="primary" @click="Bdetails.show = false">确定</Button>
            </div>
        </Modal>
        <!-- 玩家管理 -->
        <Modal v-model="modalUser.show" width="800" @on-cancel="closemodalUser">
            <p slot="header" style="color: #1c2438; text-align: center">
                <span>批量玩家管理</span>
            </p>
            <Table border :columns="modalUser.column" :data="modalUser.data"></Table>
            <div style="margin-top: 10px">
                <Form :model="modalUser.params">
                    <Row>
                        <Col span="20">
                            <FormItem label="控制方式" prop="risk_type">
                                <RadioGroup v-model="modalUser.params.risk_type">
                                    <Radio :label="2">智能风控</Radio>
                                    <Radio :label="1">手动风控</Radio>
                                </RadioGroup>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row v-if="modalUser.params.risk_type == 1">
                        <Col span="20">
                            <FormItem label="用户标签" prop="risk_tag">
                                <Select style="width: 200px" v-model="modalUser.params.risk_tag" filterable placeholder="用户标签" clearable>
                                    <Option v-for="(item, index) in select.TagList" :value="item.user_tag" :label="item.name" :key="index">
                                        {{ item.name }}<span style="color: #bbb">({{ item.user_tag }})</span>
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="16">
                            <FormItem label="自动解除控制（实际输赢达到阈值后自动解除）" prop="risk_val">
                                <InputNumber style="width: 200px" type="text" v-model="modalUser.params.risk_val" />
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <span style="color: red">阈值按照手动风控设置生效后的时间流水开始统计是否到达设定阈值（不计算历盈亏和单日盈亏）</span>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="footer">
                <Button type="warning" @click="closemodalUser">取消</Button>
                <Button type="primary" style="margin-left: 30px" @click="AddUserControl()">确定</Button>
            </div>
        </Modal>

        <!-- 操作记录详情 -->
        <Modal v-model="ControlRecord.show" width="880">
            <p slot="header" style="color: #1c2438; text-align: center">
                <span>操作记录详情</span>
            </p>
            <Table border :columns="ControlRecord.column" :data="ControlRecord.data"></Table>
            <Page v-show="ControlRecord.data.length" style="margin-top: 10px" :current="ControlRecord.params.page" :total="ControlRecord.total" :page-size-opts="pageSizes" :page-size="table.params.page_size" show-sizer @on-page-size-change="limitchangeControl" @on-change="pagechangeControl"></Page>
            <div slot="footer" style="text-align: center">
                <Button type="primary" @click="ControlRecord.show = false">确定</Button>
            </div>
        </Modal>
        <!-- 导表模块 -->
        <Modal v-model="Excel.show" width="1000">
            <p slot="header" style="color: #1c2438; text-align: center">
                <span>数据导出</span>
            </p>
            <Form :inline="true">
                <FormItem
                    label="子商户
号"
                >
                    <InputNumber
                        v-model="Excel.pack_no"
                        placeholder="子商户
号"
                        clearable
                        style="width: 180px"
                    ></InputNumber>
                </FormItem>
                <FormItem label="查询活跃时间">
                    <DatePicker :options="dateOptions" type="daterange" v-model="Excel.rdataTime" placeholder="查询活跃时间" :clearable="false" separator=" ~ " style="width: 180px"></DatePicker>
                </FormItem>
                <FormItem label="是否转入">
                    <Select v-model="Excel.if_pay" clearable placeholder="是否转入" style="width: 180px">
                        <Option v-for="item in Excel.if_payList" :key="item.value" :label="item.name" :value="item.value">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="是否绑定手机">
                    <Select v-model="Excel.if_phone" clearable placeholder="是否绑定手机" style="width: 180px">
                        <Option v-for="item in Excel.if_phoneList" :key="item.value" :label="item.name" :value="item.value">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <Button type="primary" @click="createdExcel" style="margin-top: 32.5px; margin-left: 15px">导出excel</Button>
            </Form>
            <p style="font-size: 14px; color: red">备注信息：因导出数据会影响游戏服务器的稳定性，所以限制导出时间最长为一个月的数据，导出数据最多为1万条</p>
            <Table border style="margin-top: 10px" :columns="Excel.columns" :data="Excel.data"></Table>
            <Page style="margin-top: 10px" show-total :total="Excel.total" :currentPage="Excel.currentPage" :page-size-opts="pageSizes" :page-size="Excel.limit" show-sizer @on-page-size-change="excelchange" @on-change="excelcurrentPage"></Page>
        </Modal>
    </div>
</template>
<script>
import { TransTopReq, GetAllGameList } from '@/api/admin/risk'
import { GetUserTagList, GetPuidList } from '@/api/admin/player'
import { GetToken } from '@/libs/util'
import moment from 'moment'
import Backer from '@/views/components/Backer.vue'
export default {
    name: 'activePlayers',
    components: {
        Backer
    },
    data() {
        return {
            backEnable: false,
            pageSizes: [10, 20, 30, 40],
            select: {
                smart_list: [],
                game_list: [],
                dataTime: [this.getCurrentZeroDay(), this.getCurrentZeroDay()],
                rdataTime: [],
                user_tag_List: new Array(21),
                online_list: [
                    { name: '全部', value: 0 },
                    { name: '在线', value: 1 },
                    { name: '离线', value: 2 }
                ],
                is_bet_list: [
                    { name: '全部', value: 0 },
                    { name: '投注', value: 1 },
                    { name: '未投', value: 2 }
                ],
                fistgive_list: [
                    { name: '全部', value: 0 },
                    { name: '赠送', value: 1 },
                    { name: '未赠送', value: 2 }
                ],
                fistpay_list: [
                    { name: '全部', value: 0 },
                    { name: '首充', value: 1 },
                    { name: '未首充', value: 2 }
                ],
                is_pid_list: [
                    { name: '全部', value: 0 },
                    { name: '已绑定', value: 1 },
                    { name: '未绑定', value: 2 }
                ],
                is_his_pay_list: [
                    { name: '全部', value: 0 },
                    { name: '已转入', value: 1 },
                    { name: '未转入', value: 2 }
                ],
                user_control_risk_type_list: [
                    { name: '全部', value: 0 },
                    { name: '手动风控', value: 1 },
                    { name: '智能风控', value: 2 }
                ],
                TagList: [],
                general_list: [],
                pack_list: []
            },
            //表单数据
            table: {
                params: {
                    platform: 0,
                    app_id: 0,
                    page: 1,
                    limit: 10,
                    sort: 0,
                    gid: 0,
                    is_online: '',
                    is_bet: '',
                    nick_name: '',
                    is_give: '',
                    is_pay: '',
                    pid: '',
                    is_pid: '',
                    is_fist_pay: '',
                    is_his_pay: '',
                    r_stime: 0,
                    r_etime: 0,
                    user_tag: [],
                    pack_no: '',
                    general_no: '',
                    uid: '',
                    user_control_risk_type: null
                },
                data: [],
                columns: [
                    { type: 'selection', width: 60, align: 'center', fixed: 'left' },
                    {
                        title: '玩家ID',
                        key: 'uid',
                        align: 'center',
                        minWidth: 70,
                        render: (h, params) => {
                            // if (params.row.puidname && GetToken().uid != params.row.puid) {
                            //     return h('span', params.row.uid);
                            // } else {
                            //     return this.renderModalUser(h, params);
                            // }
                            return this.renderModalUser(h, params)
                        },
                        renderHeader: (h, params) => this.renderHeader(h, '玩家ID', '显示该条数据对应的玩家ID')
                    },
                    this.renderColorCol('nickname', 2, '玩家昵称', '显示该条数据对应的玩家昵称'),
                    {
                        title: '所属子商户',
                        key: 'pack_id',
                        minWidth: 80,
                        align: 'center',
                        render: (h, params) => {
                            let str = params.row.pack_name + '(' + params.row.pack_no + ')'
                            return h('span', { style: { color: params.row.is_pack_moniter ? (Number(params.row.pack_moniter_val) > 0 && Number(params.row.pack_moniter_val) != 0 ? 'blue' : 'red') : '#333' } }, str)
                        },
                        renderHeader: (h, params) => this.renderHeader(h, '所属子商户', '显示该条数据对应玩家所属的子商户')
                    },
                    this.renderColorCol('pid', 3, '上级ID', '显示该条数据对应的玩家上级代理', 80, true),
                    { title: '当前管理员', key: 'puidname', minWidth: 90, align: 'center', render: (h, params) => h('span', params.row.puidname || '') },
                    {
                        title: '当前状态',
                        key: 'pid',
                        minWidth: 90,
                        align: 'center',
                        render: (h, params) => {
                            let str = ''
                            if (params.row.risk_type == 2) {
                                str = '智能风控'
                            } else if (params.row.risk_type == 1) {
                                let arr = this.select.TagList.filter((item) => item['user_tag'] === params.row.risk_tag)[0] || []
                                str = arr['name'] || ''
                            } else {
                                str = '无'
                            }
                            return h('span', str)
                        }
                    },
                    { title: '控制阈值', key: 'pid', minWidth: 90, align: 'center', render: (h, params) => h('span', params.row.risk_type == 0 ? '无' : params.row.risk_val) },
                    {
                        title: '记录',
                        key: 'pid',
                        minWidth: 90,
                        align: 'center',
                        render: (h, params) => {
                            return h(
                                'a',
                                {
                                    on: {
                                        click: () => {
                                            this.ControlRecord.params.uid = params.row.uid
                                            this.GetUserControl()
                                            this.ControlRecord.show = true
                                        }
                                    }
                                },
                                '操作记录'
                            )
                        }
                    },
                    {
                        title: '是否在线',
                        key: 'in_online',
                        minWidth: 60,
                        align: 'center',
                        render: (h, params) => h('span', { style: { color: params.row.in_online ? '#09d02a' : '#333' } }, params.row.in_online ? '在线' : '离线'),
                        renderHeader: (h, params) => this.renderHeader(h, '是否在线', '显示该条数据对应的玩家是否还在线')
                    },
                    this.renderSortPointCol('today_pay', '转入金额', '统计该玩家筛选时间内的转入累计金额'),
                    {
                        title: '赠送金额',
                        key: 'today_t_give',
                        minWidth: 80,
                        align: 'center',
                        sortable: true,
                        sortMethod: function (a, b, type) {},
                        render: (h, params) => {
                            return h(
                                'a',
                                {
                                    on: {
                                        click: () => {
                                            this.gift.column = this.gift.column1
                                            this.gift.data = []
                                            this.gift.data.push(params.row)
                                            this.gift.show = true
                                        }
                                    }
                                },
                                (params.row.today_t_give / 10000).toFixed(2)
                            )
                        },
                        renderHeader: (h, params) => this.renderHeader(h, '赠送金额', '统计该玩家筛选时间内的注册赠金 + 后台赠送金额 + 活动赠送金额')
                    },
                    this.renderSortPointCol('today_put', '转出金额', '统计该玩家筛选时间内的转出累计金额'),
                    this.renderSortPointCol('today_balance', '盈亏金额', '统计筛选时间内返奖金额 - 投注金额'),
                    this.renderSortPointCol('today_bet', '投注金额', '统计该玩家筛选时间内的投注累计金额'),
                    this.renderSortPointCol('today_hit', '返奖金额', '统计该玩家筛选时间内的返奖累计金额'),
                    this.renderSortPointCol('sendcommi', '业绩佣金', '显示筛选时间内，该玩家获得的业绩统计项', false, 60),
                    this.renderSortPointCol('coin', '账户余额', '显示该玩家当前的账户余额'),
                    this.renderSortPointCol('yes_coin', '昨日账户余额', '显示该玩家昨日24点时的账户余额', false, 90),
                    { title: '注册手机', key: 'phone_brand', minWidth: 100, align: 'center', render: (h, params) => h('span', `${params.row.phone_brand} ${params.row.phone_model}`) },
                    {
                        title: '最后登录手机',
                        key: 'last_phone_brand',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => h('span', `${params.row.last_phone_brand} ${params.row.last_phone_model}`)
                    },
                    this.renderSortPointCol('pay', '历史转入', '统计该玩家注册游戏之后到当前时间的累计转入金额'),
                    {
                        title: '历史赠送',
                        key: 't_give',
                        minWidth: 80,
                        align: 'center',
                        sortable: true,
                        sortMethod: function (a, b, type) {},
                        render: (h, params) => {
                            return h(
                                'a',
                                {
                                    on: {
                                        click: () => {
                                            this.gift.column = this.gift.column2
                                            this.gift.data = []
                                            this.gift.data.push(params.row)
                                            this.gift.show = true
                                        }
                                    }
                                },
                                (params.row.t_give / 10000).toFixed(2)
                            )
                        },
                        renderHeader: (h, params) => this.renderHeader(h, '历史赠送', '统计该玩家注册游戏之后到当前时间的累计注册赠金 + 后台赠送金额+活动赠送金额')
                    },
                    this.renderSortPointCol('put', '历史转出', '统计该玩家注册游戏之后到当前时间的累计转出金额'),
                    this.renderSortPointCol('banlance', '历史盈亏', '统计该玩家的历史盈亏金额，历史盈亏 = 历史返奖 - 历史投注'),
                    {
                        title: '用户标签',
                        key: 'user_tag',
                        align: 'center',
                        sortable: true,
                        minWidth: 80,
                        render: (h, params) => {
                            let color = '#333'
                            if (params.row.user_tag < 8) {
                                color = '#333'
                            } else if (params.row.user_tag > 8 && params.row.user_tag < 16) {
                                color = 'blue'
                            } else if (params.row.user_tag > 16) {
                                color = '#e96900'
                            }
                            return h('span', { style: { color: color } }, params.row.user_tag)
                        },
                        renderHeader: (h, params) => this.renderHeader(h, '用户标签', '显示玩家的标签')
                    },
                    {
                        title: '所在游戏',
                        key: 'game_name',
                        minWidth: 80,
                        align: 'center',
                        render: (h, params) => h('span', params.row.game_name == '' ? '大厅' : params.row.game_name),
                        renderHeader: (h, params) => this.renderHeader(h, '所在游戏', "显示该玩家当前所在玩的子游戏，如该玩家在大厅没有进入子游戏或离线，则统计项显示'大厅'")
                    },
                    this.renderColorCol('ctime', 4, '注册时间', '显示该玩家注册游戏账户的时间'),
                    this.renderBaseCol('ltime', '最后登录时间', '显示该玩家最后一次登录的时间', 90),
                    this.renderColorCol('ip', 5, '最后登录IP', '显示该玩家最后一次登录时使用的IP'),
                    {
                        title: '操作',
                        align: 'center',
                        minWidth: 200,
                        fixed: 'right',
                        key: 'key',
                        render: (h, params) => {
                            return h('div', [
                                h(
                                    'Button',
                                    {
                                        props: { type: 'primary' },
                                        style: { marginRight: '5px' },
                                        on: {
                                            click: () => {
                                                this.other.show = true
                                                this.other.user_id = params.row.uid
                                                this.getotherdata()
                                                this.other.show = true
                                            }
                                        }
                                    },
                                    '其他数据'
                                ),
                                h(
                                    'Button',
                                    {
                                        props: { type: 'primary' },
                                        style: { marginRight: '5px' },
                                        on: {
                                            click: () => {
                                                this.GetActiveUser(params.row.uid)
                                                this.Bdetails.show = true
                                            }
                                        }
                                    },
                                    '投注详情'
                                )
                            ])
                        }
                    }
                ],
                total: 0,
                summary: { pay_sum: 0, put_sum: 0 }
            },
            //  赠送金额
            gift: {
                show: false,
                data: [],
                column: [],
                column1: [this.renderPointCol('today_r_give', '新增注册增金', '新玩家绑定手机赠送的3金之和'), this.renderPointCol('today_give', '后台赠送金额', '运营后台手动为用户手动添加的赠送金额'), this.renderPointCol('today_a_give', '活动赠送金额', '用户通过活动获得的奖励金额'), this.renderPointCol('task_day_point', '任务领取金额', '当天该玩家领取的任务奖励金额')],
                column2: [this.renderPointCol('r_give', '新增注册增金', '新玩家绑定手机赠送的3金之和'), this.renderPointCol('give', '后台赠送金额', '运营后台手动为用户手动添加的赠送金额'), this.renderPointCol('a_give', '活动赠送金额', '用户通过活动获得的奖励金额'), this.renderPointCol('task_point', '任务领取金额', '当天该玩家领取的任务奖励金额')]
            },
            //其他数据
            other: {
                show: false,
                user_id: 0,
                column: [this.renderPointCol('fist_pay_sum', '转入金额(第一笔)', '筛选时间内，用户转入的第一笔金额'), this.renderPointCol('today_percent', '纳税金额', '统计该玩家筛选时间内纳税金额'), this.renderRateCol('loss_rate', '盈亏投注比', '筛选时间内，盈亏金额 / 投注金额'), this.renderRateCol('loss_per_rate', '盈亏税收比', '筛选时间内，盈亏金额 / 纳税金额'), this.renderPointCol('today_percent_point', '昨日推广奖励金额', '显示当前用户昨日推广带来的奖励金额；不受时间筛选项影响'), this.renderPointCol('percent_point', '历史推广奖励金额', '显示玩家注册后到当前打开界面为止获得的推广奖励之和；不受时间筛选项影响'), this.renderBaseCol('login_rate', '登录频次', '筛选时间内用户登陆APP的次数'), this.renderBaseCol('otime', '在线时长', '显示该玩家在线时长')],
                data: []
            },
            Bdetails: {
                show: false,
                column: [this.renderBaseCol('game_name', '游戏名称', '显示该条数据对应的游戏名称'), this.renderPointCol('bet_point', '投注金额', '显示时间范围内该玩家在该子游戏内的投注金额'), this.renderPointCol('hit_point', '返奖金额', '显示时间范围内该玩家在该子游戏内的返奖金额'), this.renderPointCol('loss_point', '盈亏金额', '显示时间范围内该玩家在该子游戏内的盈亏金额=返奖金额-投注金额'), this.renderRateCol('loss_rate', '盈亏投注比', '盈亏金额/投注金额'), this.renderBaseCol('bet_num', '用户投注笔数', '用户每笔注单数量'), this.renderPointCol('arpu_rate', '用户投注arpu', '用户总投注额金额/总投注笔数')],
                data: []
            },
            //操作详情
            ControlRecord: {
                show: false,
                data: [],
                column: [
                    this.renderBaseCol('ctime', '操作时间', null, 50),
                    { title: '操作管理员', key: 'puid', align: 'center', render: (h, params) => h('span', `${params.row.pname}(${params.row.puid})`) },
                    this.renderBaseCol('uid', '玩家ID', null),
                    { title: '控制阈值', key: 'risk_val', align: 'center', render: (h, params) => h('span', params.row.risk_type == 0 ? '无' : params.row.risk_val) },
                    {
                        title: '操作内容',
                        key: 'risk_type',
                        align: 'center',
                        render: (h, params) => {
                            let str = ''
                            if (params.row.risk_type == 2) {
                                str = '智能风控'
                            } else if (params.row.risk_type == 1) {
                                let arr = this.select.TagList.filter((item) => item['user_tag'] === params.row.risk_tag)[0] || []
                                str = arr['name'] || ''
                            } else {
                                str = '无'
                            }
                            return h('span', str)
                        }
                    },
                    this.renderPointCol('bet', '投注金额'),
                    this.renderPointCol('hit', '返奖金额'),
                    this.renderPointCol('win', '盈亏金额'),
                    this.renderBaseCol('last_time', '最后执行时间', null, 50)
                ],
                params: { platid: 0, app_id: 0, uid: 0, page: 1, page_size: 10 },
                total: 0
            },
            //批量玩家管理
            modalUser: {
                show: false,
                data: [],
                column: [
                    this.renderBaseCol('uid', '玩家ID', '显示该条数据对应的玩家ID', 70),
                    this.renderColorCol('nickname', 2, '玩家昵称', '显示该条数据对应的玩家昵称'),
                    this.renderColorCol('pid', 3, '上级ID', '显示该条数据对应的玩家上级代理'),
                    this.renderBaseCol('puidname', '当前管理员', null, 90),
                    this.renderSortPointCol('banlance', '实际输赢', '统计该玩家的历史盈亏金额，历史盈亏 = 历史返奖 - 历史投注', false),
                    {
                        title: '操作记录',
                        align: 'center',
                        fixed: 'right',
                        minWidth: 90,
                        render: (h, params) => {
                            return h('div', [
                                h(
                                    'Button',
                                    {
                                        props: { type: 'primary' },
                                        on: {
                                            click: () => {
                                                this.ControlRecord.params.uid = params.row.uid
                                                this.GetUserControl()
                                                this.ControlRecord.show = true
                                            }
                                        }
                                    },
                                    '查看详情'
                                )
                            ])
                        }
                    }
                ],
                params: { risk_type: 2, risk_tag: 0, risk_val: 0 }
            },
            //导出
            Excel: {
                show: false,
                rdataTime: [new Date(new Date().setHours(0, 0, 0, 0) - 30 * 24 * 3600 * 1000), this.getCurrentZeroDay()],
                ldataTime: [],
                stime: [this.getCurrentZeroDay(), new Date()],
                pack_no: null,
                data: [],
                columns: [
                    this.renderBaseCol('create_time', '导出数据时间', null, 85),
                    {
                        key: 'pack_no',
                        title: '所属子商户',
                        align: 'center',
                        render: (h, params) => {
                            let data = JSON.parse(params.row.data)
                            let str = data.pack_no == -1 ? '全部' : data.pack_no
                            return h('span', str)
                        }
                    },
                    {
                        key: 'r_stime',
                        title: '活跃时间',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            let data = JSON.parse(params.row.data)
                            let str =
                                data.r_stime * 1000 != 0
                                    ? moment(data.r_stime * 1000)
                                          .locale('zh-cn')
                                          .format('YYYY-MM-DD') +
                                      '~' +
                                      moment(data.r_etime * 1000)
                                          .locale('zh-cn')
                                          .format('YYYY-MM-DD')
                                    : ''
                            return h('span', str)
                        }
                    },
                    {
                        key: 'if_pay',
                        title: '是否转入',
                        align: 'center',
                        render: (h, params) => {
                            let data = JSON.parse(params.row.data)
                            let arr = ['全部', '已转入', '未转入']
                            let str = arr[data.if_pay] || ''
                            return h('span', str)
                        }
                    },
                    {
                        key: 'if_phone',
                        title: '是否绑定手机',
                        align: 'center',
                        render: (h, params) => {
                            let data = JSON.parse(params.row.data)
                            let arr = ['全部', '已绑定', '未绑定']
                            return h('span', arr[data.if_phone] || '')
                        }
                    },
                    {
                        key: 'status',
                        title: '导出状态',
                        align: 'center',
                        render: (h, params) => {
                            let str = params.row.status ? '已完成' : '未完成'
                            return h('span', { style: { color: params.row.status ? 'green' : 'red' } }, str)
                        }
                    },
                    this.renderBaseCol('desc', '原因', null),
                    this.renderBaseCol('user_id', '操作人', null),
                    {
                        key: 'pack_no',
                        title: '操作状态',
                        align: 'center',
                        width: 180,
                        render: (h, params) => {
                            return h('div', [
                                h(
                                    'Button',
                                    {
                                        props: {
                                            type: 'primary',
                                            disabled: params.row.status ? false : true
                                        },
                                        style: { margin: '2px', padding: '3px 8px' },
                                        on: {
                                            click: () => {
                                                this.downloadexcel(params.row.url, '转出订单数据')
                                            }
                                        }
                                    },
                                    params.row.status ? '下载数据表' : '等待完成'
                                ),
                                h(
                                    'Button',
                                    {
                                        props: { type: 'error' },
                                        style: { margin: '2px', padding: '3px 8px' },
                                        on: {
                                            click: () => {
                                                // this.removemsg(params.row.id)
                                            }
                                        }
                                    },
                                    '删除记录'
                                )
                            ])
                        }
                    }
                ],
                total: 0,
                limit: 10,
                currentPage: 1,
                if_put: 0,
                if_putList: [
                    { value: 0, name: '全部' },
                    { value: 1, name: '已转出' },
                    { value: 2, name: '未转出' }
                ],
                is_pid: '',
                if_pay: 0,
                if_payList: [
                    { value: 0, name: '全部' },
                    { value: 1, name: '已转入' },
                    { value: 2, name: '未转入' }
                ],
                if_phone: 0,
                if_phoneList: [
                    { value: 0, name: '全部' },
                    { value: 1, name: '已绑定' },
                    { value: 2, name: '未绑定' }
                ]
            }
        }
    },
    methods: {
        returnParam(func, params, margin) {
            return {
                mod: 'root',
                platid: this.table.params.platform,
                app_id: this.table.params.app_id,
                param: {
                    _mod: margin ? 'root' : 'manager',
                    _func: func,
                    _param: { ...params }
                }
            }
        },
        //GeneralList//获取商户列表
        getGeneralList() {
            TransTopReq(this.returnParam('GetAppGeneralList', { app_id: this.table.params.app_id })).then((res) => {
                this.select.general_list = res._param.general_list || []
            })
        },
        //GeneralList//获取商户列表
        GetPackList() {
            TransTopReq(this.returnParam('GetPackList', { app_id: this.table.params.app_id })).then((res) => {
                this.select.pack_list = res._param.pack_list || []
            })
        },
        renderModalUser(h, params) {
            return h(
                'a',
                {
                    on: {
                        click: () => {
                            this.modalUser.data = []
                            this.modalUser.data.push(params.row)
                            let { risk_type, risk_tag, risk_val } = params.row
                            Object.assign(this.modalUser.params, { risk_type, risk_tag, risk_val })
                            this.modalUser.show = true
                        }
                    }
                },
                params.row.uid
            )
        },
        appidChange(data) {
            if (data) {
                this.getGeneralList()
                this.GetPackList()
            }
        },
        //服务器排序
        changeSort(data) {
            let arr = ['today_pay', 'today_t_give', 'today_put', 'today_balance', 'today_bet', 'today_hit', 'today_percent', 'loss_rate', 'loss_per_rate', 'pay', 't_give', 'put', 'banlance', 'bet', 'hit', 'fist_pay_sum', 'pid']
            let index = arr.findIndex((el) => el == data.key)
            let offset = data.order == 'desc' ? 1 : 2
            if (index != -1) {
                this.table.params.sort = index * 2 + offset
            }
            this.getUserRiskList(1)
        },
        //获取列表
        getUserRiskList(num) {
            if (num) this.table.params.page = 1
            let [stime, etime] = this.select.dataTime
            let [r_stime, r_etime] = this.select.rdataTime
            let params = {
                ...this.table.params,
                stime: this.getSecond(stime) || 0,
                etime: this.getSecond(etime, false) || 0,
                r_stime: this.getSecond(r_stime) || 0,
                r_etime: this.getSecond(r_etime, false) || 0,
                pack_no: this.table.params.pack_no.length == 0 ? -1 : Number(this.table.params.pack_no),
                general_no: this.table.params.general_no.length == 0 ? -1 : Number(this.table.params.general_no),
                pid: Number(this.table.params.pid),
                is_give: Number(this.table.params.is_give),
                is_pid: Number(this.table.params.is_pid),
                is_fist_pay: Number(this.table.params.is_fist_pay),
                is_his_pay: Number(this.table.params.is_his_pay),
                sort: Number(this.table.params.sort),
                gid: Number(this.table.params.gid),
                app_id: Number(this.table.params.app_id),
                is_online: Number(this.table.params.is_online),
                is_bet: Number(this.table.params.is_bet),
                is_pay: Number(this.table.params.is_pay),
                uid: Number(this.table.params.uid),
                user_control_risk_type: Number(this.table.params.user_control_risk_type)
            }
            // TransTopReq()
            TransTopReq(this.returnParam('ActiveUserControl', params)).then((res) => {
                this.table.summary.put_sum = res._param.put_sum / 10000 || 0
                this.table.summary.pay_sum = res._param.pay_sum / 10000 || 0
                let params1 = { ...res._param }
                TransTopReq(this.returnParam('ActiveUserControl2', params1)).then((res1) => {
                    let list = res1._param.data || []
                    if (list.length > 0) {
                        let puids = list.map((item) => item.puid)
                        GetPuidList({ puids })
                            .then((data) => {
                                let puidList = data._param.list || []
                                puidList.forEach((el, index) => {
                                    list[index].puidname = el.name
                                    list[index]._disabled = !!el.name
                                })
                            })
                            .then(() => {
                                this.table.data = list || []
                            })
                    } else {
                        this.table.data = []
                    }
                    this.table.total = res1._param.total || 0
                })
            })
        },
        renderColorCol(key, index, title, tip, minWidth = 80, sortable = false) {
            return {
                title,
                key,
                minWidth,
                sortable,
                sortMethod: function (a, b, type) {},
                align: 'center',
                render: (h, params) => h('span', { style: { color: params.row.types.indexOf(index) > -1 ? 'red' : '#333' } }, params.row[key]),
                renderHeader: (h, params) => this.renderHeader(h, title, tip)
            }
        },
        renderBaseCol(key, title, tip, minWidth) {
            let result = { title, key, minWidth, align: 'center' }
            if (tip) Object.assign(result, { renderHeader: (h, params) => this.renderHeader(h, title, tip) })
            return result
        },
        renderRateCol(key, title, tip) {
            return { title, key, align: 'center', render: (h, params) => h('span', (params.row[key] * 100).toFixed(2) + '%'), renderHeader: (h, params) => this.renderHeader(h, title, tip) }
        },
        renderPointCol(key, title, tip) {
            let result = { title, key, align: 'center', render: (h, params) => h('span', (params.row[key] / 10000).toFixed(2)) }
            if (tip) Object.assign(result, { renderHeader: (h, params) => this.renderHeader(h, title, tip) })
            return result
        },
        renderSortPointCol(key, title, tip, sortable = true, minWidth = 80) {
            return {
                title,
                key,
                minWidth: 80,
                align: 'center',
                sortable,
                sortMethod: function (a, b, type) {},
                render: (h, params) => h('span', (params.row[key] / 10000).toFixed(2)),
                renderHeader: (h, params) => this.renderHeader(h, title, tip)
            }
        },
        //列表分页
        pagechange(page) {
            this.table.params.page = page
            this.getUserRiskList()
        },
        //列表分条
        limitchange(limit) {
            this.table.params.page = 1
            this.table.params.limit = limit
            this.getUserRiskList()
        },
        getActiveParams(id) {
            let [stime, etime] = this.select.dataTime
            return {
                app_id: Number(this.table.params.app_id),
                user_id: id ? Number(id) : Number(this.other.user_id),
                stime: this.getSecond(stime) || 0,
                etime: this.getSecond(etime, false) || 0
            }
        },
        //其他数据
        getotherdata() {
            let params = this.getActiveParams()
            TransTopReq(this.returnParam('GetActiveUserOtherData', params)).then((res) => {
                this.other.data = []
                this.other.data.push(res._param)
            })
        },
        // 投注信息
        GetActiveUser(id) {
            let params = this.getActiveParams(id)
            TransTopReq(this.returnParam('GetActiveUserBetInfo', params)).then((res) => {
                this.Bdetails.data = res._param.data || []
            })
        },
        //获取选中项
        getSelection(selection) {
            this.modalUser.data = selection || []
        },
        modalUserShow() {
            if (!this.modalUser.data.length) return this.$Message.error('请选择需要管理的玩家')
            this.modalUser.params = { risk_type: 2, risk_tag: 0, risk_val: 0 }
            this.modalUser.show = true
        },
        closemodalUser() {
            this.modalUser.data = []
            this.$refs.selection.selectAll(false)
            this.modalUser.show = false
        },
        AddUserControl() {
            let uids = this.modalUser.data.map((item) => item['uid']) || []
            let params = {
                platid: this.table.params.platform,
                app_id: this.table.params.app_id,
                uids: uids,
                puid: GetToken().uid,
                ...this.modalUser.params
            }
            TransTopReq(this.returnParam('AddUserControlList', params, 1)).then((res) => {
                this.getUserRiskList()
                this.modalUser.show = false
            })
        },

        //玩家管理操作记录
        GetUserControl(num) {
            if (num) {
                this.ControlRecord.params.page = 1
            }
            let params = {
                ...this.ControlRecord.params,
                platid: this.table.params.platform,
                app_id: this.table.params.app_id
            }
            TransTopReq(this.returnParam('GetUserControlRecord', params, 1)).then((res) => {
                let list = res._param.list || []
                let puids = []
                if (list.length > 0) {
                    list.map((item) => {
                        puids.push(item.puid)
                    })
                    GetPuidList({ puids: puids })
                        .then((data) => {
                            let puidList = data._param.list || []
                            puidList.forEach((el, index) => {
                                list[index].index = el.name
                            })
                        })
                        .then(() => {
                            this.ControlRecord.data = list || []
                        })
                } else {
                    this.ControlRecord.data = []
                }
                this.ControlRecord.total = res._param.total || 0
            })
        },
        limitchangeControl(limit) {
            this.ControlRecord.params.page = 1
            this.ControlRecord.params.page_size = limit
            this.GetUserControl()
        },
        pagechangeControl(page) {
            this.ControlRecord.params.page = page
            this.GetUserControl()
        },
        //获取导表列表
        GetExcelList() {
            this.Excel.show = true
            let param = {
                app_id: this.table.params.app_id,
                user_id: 0,
                type: 1003,
                status: -1,
                page: this.Excel.currentPage,
                limit: this.Excel.limit
            }
            TransTopReq(this.returnParam('NewGetTickList', param)).then((res) => {
                this.Excel.data = res._param.list || []
                this.Excel.total = res._param.total || 0
            })
        },
        //创建导表
        createdExcel() {
            let [stime, etime] = this.Excel.ldataTime
            let [r_stime, r_etime] = this.Excel.rdataTime
            let data = {
                l_stime: this.getSecond(stime) || 0,
                l_etime: this.getSecond(etime, false) || 0,
                r_stime: this.getSecond(r_stime) || 0,
                r_etime: this.getSecond(r_etime, false) || 0,
                pack_no: typeof this.Excel.pack_no != 'number' ? -1 : Number(this.Excel.pack_no),
                if_pay: typeof this.Excel.if_pay != 'number' ? 0 : Number(this.Excel.if_pay),
                if_phone: typeof this.Excel.if_phone != 'number' ? 0 : Number(this.Excel.if_phone),
                if_put: typeof this.Excel.if_put != 'number' ? 0 : Number(this.Excel.if_put)
            }
            let param = { app_id: this.table.params.app_id, type: 1003, desc: '', data: JSON.stringify(data) }
            TransTopReq(this.returnParam('NewCreateTick', param)).then((res) => {
                this.$Message.success('创建成功，请稍候下载')
                this.GetExcelList()
            })
        },
        //下载excel
        downloadexcel(data, name) {
            if (!data) return
            let aTag = document.createElement('a')
            aTag.href = data
            aTag.download = data
            aTag.click()
        },
        //删除导表数据
        DelTickexcel(id) {
            let param = { app_id: this.table.params.app_id, id }
            TransTopReq(this.returnParam('NewDelTick', param)).then((res) => {
                this.$Message.success('删除成功')
                this.GetExcelList()
            })
        },
        //删除导表数据弹窗
        removemsg(id) {
            this.$Modal.confirm({
                title: '删除记录',
                content: '<p>是否从后台列表中删除本条导出记录?, 是否继续?</p>',
                onOk: () => {
                    this.DelTickexcel(id)
                }
            })
        },
        //分页
        excelchange(limit) {
            this.Excel.currentPage = 1
            this.Excel.limit = limit
            this.GetExcelList()
        },
        //分条
        excelcurrentPage(page) {
            this.Excel.currentPage = page
            this.GetExcelList()
        },

        //获取标签列表
        TagList() {
            GetUserTagList({}).then((res) => {
                this.select.TagList = res._param.list || []
            })
        },
        initFunc() {
            this.table.params.platform = this.getinitPlatId()
            this.table.params.app_id = this.app_list.find((item) => item.platform == this.table.params.platform).appid
            this.getUserRiskList()
        }
    },

    activated() {
        let getDate = true
        let { back, user_id, platid, app_id } = this.$route.query
        if (back == '1') {
            if (back != null) {
                this.backEnable = true
                getDate = false
            }
            if (user_id != null) {
                this.table.params.uid = String(user_id)
            }
            if (platid != null) {
                this.table.params.platform = Number(platid)
            }
            if (app_id != null) {
                this.table.params.app_id = Number(app_id)
            }
        }
        if (getDate) {
            this.initFunc()
        } else {
            this.getUserRiskList()
        }
    },
    created() {
        GetAllGameList({ gtype: 0, page: 1, page_size: 10000 }).then((res) => {
            this.select.game_list = res._param.data || []
        })
        this.TagList()
    }
}
</script>
<style lang="less" scoped>
.btn_batch {
    margin-right: 12px;
}
</style>
